import { Box, Typography, createStyles, makeStyles } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { ReservationCard } from '../..';
import illustration from './assets/images/ic-calendar.svg';
var useStyle = makeStyles(function (theme) {
    return createStyles({
        address: {
            color: theme.palette.grey[800],
        },
        btn: {
            marginTop: 40,
            width: 250,
        },
        date: {
            color: theme.palette.primary.light,
            fontSize: 24,
            fontWeight: 'bold',
            lineHeight: 1.09,
            marginBottom: 8,
            marginTop: 16,
        },
        illustration: {
            marginBottom: 16,
        },
        name: {
            color: theme.palette.grey[800],
            fontSize: 22,
            fontWeight: 'bold',
            lineHeight: 1.09,
            marginBottom: 16,
        },
        price: {
            color: theme.palette.grey[800],
            fontSize: 16,
            fontWeight: 'bold',
            lineHeight: 1.09,
            marginBottom: 16,
        },
        title: {
            color: theme.palette.primary.light,
            fontSize: 22,
            fontWeight: 'bold',
            lineHeight: 1.09,
            marginBottom: 32,
        },
    });
});
export default (function (_a) {
    var name = _a.name, zipcode = _a.zipcode, city = _a.city, address = _a.address, date = _a.date, price = _a.price, reservationId = _a.reservationId, title = _a.title, children = _a.children;
    var styles = useStyle({});
    return (React.createElement(ReservationCard, null,
        React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "center", style: { marginTop: 24 } },
            React.createElement("img", { className: styles.illustration, src: illustration, alt: "illustration calendrier" }),
            React.createElement(Typography, { className: styles.title }, title),
            React.createElement(Typography, { className: styles.name }, name),
            React.createElement(Typography, { className: styles.address }, address),
            React.createElement(Typography, { className: styles.address },
                zipcode,
                " - ",
                city),
            React.createElement(Typography, { className: styles.date }, moment(date).format('dddd DD MMMM - HH:mm')),
            price && React.createElement(Typography, { className: styles.price },
                price,
                "\u20AC"),
            React.createElement(Typography, { className: styles.address },
                "ID R\u00E9servation : ",
                reservationId),
            children)));
});
//# sourceMappingURL=index.js.map